import React from 'react';
import { useMyUserId } from '../../../../../data/hooks/sessionHooks';
import { isMeetingCreatedByUser } from '../../../../../data/filters/meetings/isMeetingCreatedByUser';
import { isMeetingCancelled, isMeetingConfirmed, isMeetingPending, isMeetingRejected } from 'common-data-handling';
import styles from './MeetingState.module.scss';
import { useI18n } from '../../../../../data/hooks/i18nHooks';

const DEFAULTS = {
    pendingCreator: { className: styles.pending, text: 'meeting.status.waiting-for-response' },
    pendingInvited: { className: styles.pending, text: 'meeting.status.awaiting-your-response' },
    confirmed: { className: styles.confirmed, text: 'meeting.status.confirmed' },
    rejected: { className: styles.rejected, text: 'meeting.status.rejected' },
    cancelled: { className: styles.cancelled, text: 'meeting.status.cancelled' },
};

function MeetingState(props) {
    const { className = '', meeting } = props,
        selfId = useMyUserId(),
        selfInitiated = isMeetingCreatedByUser(selfId, meeting),
        i18n = useI18n();

    let state;
    if (isMeetingConfirmed(meeting)) {
        state = DEFAULTS.confirmed;
    } else if (isMeetingPending(meeting) && selfInitiated) {
        if (selfInitiated) {
            state = DEFAULTS.pendingCreator;
        } else {
            state = DEFAULTS.pendingInvited;
        }
    } else if (isMeetingCancelled(meeting)) {
        if (isMeetingRejected(meeting)) {
            state = DEFAULTS.rejected;
        } else {
            state = DEFAULTS.cancelled;
        }
    }

    if (!state) return null;

    const { className: stateClassName, text } = state;

    return <div className={[className, styles.MeetingState, stateClassName].join(' ')}>{i18n[text]}</div>;
}

export default MeetingState;
